import { Injectable } from '@angular/core';
import { ContextService } from '../application/context.service';
import { APIService } from '../application/api.service';
import { IAppContext } from 'src/app/framework/interfaces';
import * as FW from "../../framework/core";
import { WarningLevel } from 'src/app/framework/enums';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ProtocolService {
    public get serviceName(): string { return "Protocol" };

    constructor(public context: ContextService, private api: APIService,
        private httpClient: HttpClient) {
    }

    public inconsistencyReport(startDate, endDate): Observable<FW.Envelope<any>> {
        const ctx: IAppContext = this.context.join(this.serviceName);
        const postEnvelope = new FW.Envelope({
            startDate: startDate,
            endDate: endDate
        });

        return this.httpClient.post<FW.Envelope<any>>(
            environment.baseApiUrl + '/protocol/inconsistencyreport',
            postEnvelope,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            });
    }
}
